import styled from "styled-components";
import {media} from "assets/css/media";
import budweiserBg from 'assets/images/budweiserBg.png'

export const LeaguePageWrapper = styled.div`
	background: ${({theme}) => theme.global.leagues_background};
	padding-top: 40px;
	padding-bottom: 80px;
	min-height: 1200px;
`;

const getBackgroundImage = (isBudweiserTheme: boolean) => {
	if (!isBudweiserTheme) return ''
	return `
		background-image: url(${budweiserBg});
		background-repeat: no-repeat;
		background-position: top;
		background-size: contain;
	`
}

export const LeagueSubPageWrapper = styled.div<{isBudweiserTheme: boolean}>`
	background-color: ${({theme, isBudweiserTheme}) => isBudweiserTheme ? '#A92222' : theme.global.leagues_background};
	padding-top: 40px;
	padding-bottom: 80px;
	min-height: 1200px;
	
	${({isBudweiserTheme}) => getBackgroundImage(isBudweiserTheme)}

	@media screen and (max-width: ${media.mobile}) {
		padding-bottom: 0;
		background-image: unset;
	}
`;

export const PageTitle = styled.h1<{isBudweiserTheme?: boolean}>`
	font-weight: 600;
	font-size: 24px;
	font-family: "Qatar2022", sans-serif;
	line-height: 120%;
	color: ${({theme, isBudweiserTheme}) => isBudweiserTheme ? '#fff' : theme.global.leagues_text_secondary};

	@media screen and (max-width: ${media.mobile}) {
		font-size: 20px;
	}
`;

export * from "./LeagueNavigation";
export * from "./RankingsTable";
export * from "./UserTable";
export * from "./LeagueFilters";
export * from "./NoScoring";
